<svg
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 38 38"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.33301 19C6.33301 18.1255 7.04189 17.4167 7.91634 17.4167H30.083C30.9575 17.4167 31.6663 18.1255 31.6663 19V19C31.6663 19.8745 30.9575 20.5833 30.083 20.5833H7.91634C7.04189 20.5833 6.33301 19.8745 6.33301 19V19ZM6.33301 11.0833C6.33301 10.2089 7.04189 9.5 7.91634 9.5H30.083C30.9575 9.5 31.6663 10.2089 31.6663 11.0833V11.0833C31.6663 11.9578 30.9575 12.6667 30.083 12.6667H7.91634C7.04189 12.6667 6.33301 11.9578 6.33301 11.0833V11.0833ZM6.33301 26.9167C6.33301 27.7911 7.04189 28.5 7.91634 28.5H30.083C30.9575 28.5 31.6663 27.7911 31.6663 26.9167V26.9167C31.6663 26.0422 30.9575 25.3333 30.083 25.3333H7.91634C7.04189 25.3333 6.33301 26.0422 6.33301 26.9167V26.9167Z"
    [attr.fill]="isMobileMenuOpen ? '#fff' : color"
  />
</svg>
